import React from 'react';
import { Bar, BarChart, Tooltip } from 'recharts';
import { formatWithSpaces } from '../../../utils/simulation/panel';
import './EpargneChart.css';

const EpargneChart = ({ data, epargne }) => {
	return (
		<BarChart className="epargneBarChart" data={data} responsive>
			<Tooltip
				allowEscapeViewBox={{ x: true, y: true }}
				formatter={(value: number) => formatWithSpaces(value)}
				labelFormatter={(_label: string, payload) => payload[0].payload.name}
				offset={{ x: -100, y: 0 }}
			/>
			<Bar
				dataKey="value"
				fill={epargne >= 0 ? '#2193ac' : '#a61f43'}
				name="Valeur"
			/>
		</BarChart>
	);
};

export default EpargneChart;
